import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DiHomePageService } from "./di-home-page.service";
import { LandingPaginationDTO , DataService} from "../bpg-common/services/data.services";

import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { SelfService } from "../bpg-self-services/self-services.service.ts";
import { BpgCommonService } from "../bpg-common/services/bpg-common.service";
import { Router } from "@angular/router";
@Component({
  selector: "app-bpg-di-home-page",
  templateUrl: "./bpg-di-home-page.component.html",
  styleUrls: ["./bpg-di-home-page.component.css"],
})
export class BpgDiHomePageComponent implements OnInit {
  landingdata: any;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  diErgNewsList: any;
  naacAffiliateList: any;
  reTeamList: any;
  newsTitle: string;
  newsDescription: string;
  newsCreatedDateTime: string;
  newsLink: string;
  diMasterList: any;
  diBanner: string;
  diName: string;
  diAbout: string;
  diResouceList: any;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  loginUserId:any = this.loginDetails['userId'];
  pageLimit = 500;
  flag1 = false;
  flag2 = false;
  flag3 = false;
  flag4 = false;
  msg1: string;
  method: string;
  param: string;
  bannerResponseList: any = [];
  numberOfElements: number;
  noDataFound = false;
  imageURL: any;
  imagecount = 0;
  interval = 5000;
  landingData: any;
  folderNameList: any;
  fileList: any = [];
  Maxmin = "+";

  ergList: any = [];
  selectedBpg: any;
  bpgId: any;
  siteList: any = [];
  allsiteList: any = [];
  ergListDetails: any = [];
  totalMembershipCount: any;
  totalChapters: any;
  totalSites: any;
  fontFamilyConstant = "Montserrat-light";
  @ViewChild("areaMapUSA", { static: true }) areaMapUSA: ElementRef;
  @ViewChild("areaMapCanada", { static: true }) areaMapCanada: ElementRef;
  @ViewChild("areaMapMexico", { static: true }) areaMapMexico: ElementRef;
  membershipCountConstant = "Membership Count:";
  //@ViewChild("expandAreaChart", { static: true}) expandAreaChart: ElementRef;
  // @ViewChild('myInput', { static: true }) myInputVariable: ElementRef;
  /**
   * @class BpgDiHomePageComponent
   * @constructor
   */
  constructor(
    private readonly  diHomeService: DiHomePageService,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly userService: SelfService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly data: DataService,
    private readonly router:Router
  ) {}

  ngOnInit() {


    localStorage.removeItem("searchedEventsCaledarItems");

    if(localStorage.getItem("redirectURl") != null && localStorage.getItem("redirectURl") != undefined){
     const url = localStorage.getItem("redirectURl");
     const parsedUrl = new URL(url);
     const urlSegments = parsedUrl.pathname.split('/').filter(segment => segment);
      const [firstSegment, secondSegment] = urlSegments;
    if(secondSegment!=null && secondSegment!=undefined && (firstSegment==='event-view-details' || firstSegment==='expense-claim' || firstSegment === 'claim-expense-approval')) {
        this.router.navigate([`/${firstSegment}`, `${secondSegment}`]);
        localStorage.removeItem("redirectURl");
    }else if(firstSegment === 'omnidashboard') {
        const viewParam = parsedUrl.searchParams.get('view');
        this.router.navigate(['/omnidashboard'], { queryParams: viewParam ? { view: viewParam } : {} });
        localStorage.removeItem("redirectURl");
    }else{
      window.scrollTo({ left: 0, top: 0, behavior: "smooth" });

    const adminId = localStorage.getItem('adminId');
        if(adminId!=null && adminId!=undefined && adminId==='1') {
         this.router.navigate(['/erg-admin-home']);
        }else{
          this.spinnerService.show();

          this.bpgCommonService.isTokenPresent.subscribe(tokenRes => {
            if (tokenRes) {
              this.getdiBannerList();
            }
          });
          window.setInterval(() => {
            this.getDiResouceList();
          }, (1620000)); //Calls every 27 minutes
        }
     }
    }else{
      window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
       const adminId = localStorage.getItem('adminId');
         if(adminId!=null && adminId!=undefined && adminId==='1') {
            this.router.navigate(['/erg-admin-home']);
           }else{
             this.spinnerService.show();
   
             this.bpgCommonService.isTokenPresent.subscribe(tokenRes => {
               if (tokenRes) {
                 this.getdiBannerList();
               }
             });
             window.setInterval(() => {
               this.getDiResouceList();
             }, (1620000));// Calls every 27 minutes
           }
    }

  }

  /** To get Di Master Data
   * @class BpgDiHomePageComponent
   * @method getDiMasterList
   */
  getDiMasterList() {
    this.LandingPaginationDTO.size = this.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "diName";
    this.LandingPaginationDTO.filter = { diFlag: "diHomePage" };

    this.diHomeService
      .getDiMasterList(this.LandingPaginationDTO)
      .subscribe((data) => {
        this.diMasterList = data.content;
        this.diBanner = this.diMasterList[0].diBanner;
        this.diName = this.diMasterList[0].diName;
        this.diAbout = this.diMasterList[0].diAbout;
      });
  }

  /** To get BPG News Data
   * @class BpgDiHomePageComponent
   * @method getBpgNewsList
   */
  getBpgNewsList() {
    this.LandingPaginationDTO.size = this.pageLimit;
    this.LandingPaginationDTO.sortDirection = "DESC";
    this.LandingPaginationDTO.sortProperty = "modifiedDateTime";
    this.LandingPaginationDTO.filter = { diFlag: "diHomePage" };
    this.diHomeService
      .getDiNewsList(this.LandingPaginationDTO)
      .subscribe((data) => {
        this.diErgNewsList = data.content;
        for (const newss of this.diErgNewsList) {
          newss.wordCount = 0;
          if (newss.imageCheck === false) {
            newss.diNewsName = "/assets/images/news_logo.jpg";
          }
        }
        for (const news of this.diErgNewsList) {
          if (
            news.diNewsDesc !== null &&
            news.diNewsDesc !== "" &&
            news.diNewsDesc !== undefined
          ) {
            news.wordCount =
            news.diNewsDesc.split(" ").length;
            if (news.wordCount >= 30) {
              news.minWord = news.diNewsDesc.slice(0, 160);
              news.minWord =
              news.minWord + "...";
              news.showFullWord = false;
            } else{ news.showFullWord = true;}
          } else {
            news.showFullWord = true;
          }
        }
        const element = document.getElementById("newsId");
        if (this.diErgNewsList.length === 2) {
          element.className = "news-scroll";
          element.style["animationDuration"] =
            `${this.diErgNewsList.length * 6 }s`;
        } 
        // else if (this.diBpgNewsList.length > 2) {
        //   element.className = "news-scroll";
        //   element.style["animationDuration"] =
        //   `${this.diBpgNewsList.length * 3.5 }s`;
        // }
         else {
          element.className = "none";
        }
      });
  }

 
  /** get banner image list
   * @class BannerImage
   * @method getdiBannerList
   */
  getdiBannerList() {
    this.LandingPaginationDTO.size = this.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "diId";
    this.LandingPaginationDTO.filter = { diFlag: "diSelfService" };
    this.userService
      .getdiBannerList(this.LandingPaginationDTO)
      .subscribe((data) => {
        this.bannerResponseList = data.content;
        this.imageURL = this.bannerResponseList[0].diName;
        this.imagecount = 1;
        this.spinnerService.hide();
        this.numberOfElements = data.totalElements;
        if (this.bannerResponseList.length === 0) {
          this.noDataFound = true;
        }
        else {
          this.noDataFound = false;
        }
        // this.getBpgNewsList();
        this.getDiResouceList();
        this.getDiFolderList();
        this.getRegionalTeamList();

          this.data.isBanner.subscribe(data =>
             {
              if(data)
              {
                this.showImage();

              }
             })
             
        this.loadMap();
        this.getAllErgs();
      });
  }
  public showImage() {
    setInterval(() => {
      // this.imageSlideshow();
    }, this.interval);
  }

  public imageSlideshow() {
    this.imageURL = this.bannerResponseList[this.imagecount].diName;
    if (this.imagecount < this.bannerResponseList.length - 1){
      this.imagecount += 1;}
    else{ this.imagecount = 0;}
  }
  /** To get Regional Team Data
   * @class BpgDiHomePageComponent
   * @method getRegionalTeamList
   */
  getRegionalTeamList() {
    this.LandingPaginationDTO.size = this.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "regionalOrder";
    this.LandingPaginationDTO.filter = { diFlag: "diHomePage" };

    this.diHomeService
      .getEngagementTeamList(this.LandingPaginationDTO)
      .subscribe((data) => {
        this.reTeamList = data.content;
      });
  }

  /** get Bpg list
   * @class Bpg list
   * @method getAllBpg
   */
  getAllErgs() {
   const landingDto = {
      filter: {},
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: 0,
      sortDirection: "ASC",
      sortProperty: "",
      uid: "",
    };
    this.userService.getAllBpg(landingDto).subscribe((data) => {
      this.ergList = data;
      if (this.ergList.length > 0) {
        this.ergList.unshift({ bpgId: 0, bpgName: "All ERG's" });
      }
    });
  }

  /** get Site list
   * @class Site list
   * @method selectSite
   */
  selectSite(selectedErgId) {
    this.bpgId = selectedErgId;
    const mapArrayUSA = [];
    const mapArrayCanada = [];
    const mapArrayMexico = [];

    const bpgData = {
      filter: {
        userId: "0",
        bpgId: this.bpgId,
      },
      moduleId: 0,
      page: 0,
      presentRole: "string",
      searchTerm: "string",
      size: 0,
      sortDirection: "ASC",
      sortProperty: "string",
      uid: "string",
    };
    this.userService.getEachBpg(bpgData).subscribe((data) => {
      this.ergListDetails = data;

      this.totalMembershipCount = this.ergListDetails.totalMembershipCount;
      this.totalSites = this.ergListDetails.totalSites;
      this.totalChapters = this.ergListDetails.totalChapters;

      const landingData = {
        filter: {
          userId: "0",
          bpgId: this.bpgId,
        },
        moduleId: 0,
        page: 0,
        presentRole: "string",
        searchTerm: "string",
        size: 0,
        sortDirection: "ASC",
        sortProperty: "string",
        uid: "string",
      };
      this.userService.getsiteMap(landingData).subscribe((data) => {
        this.siteList = data;

        for (const site of this.siteList) {
          if (site.countryName === "USA"){
            mapArrayUSA.push({
              z: site.membershipCount,
              membershipCount: site.membershipCount,
              parentState: site.siteName,
              lat: site.siteLatitude,
              lon: site.siteLongitude,
            });
          }
          if (site.countryName === "Canada"){
            mapArrayCanada.push({
              z: site.membershipCount,
              membershipCount: site.membershipCount,
              parentState: site.siteName,
              lat: site.siteLatitude,
              lon: site.siteLongitude,
            });
          }
          if (site.countryName === "Mexico"){
            mapArrayMexico.push({
              z: site.membershipCount,
              membershipCount: site.membershipCount,
              parentState: site.siteName,
              lat: site.siteLatitude,
              lon: site.siteLongitude,
            });
          }
        }

        //fetch USA sites
        {
          const HighchartsUSA = require("highcharts/highmaps.js"),
            USAmap = require("@highcharts/map-collection/countries/us/custom/us-all-mainland.geo.json");

          HighchartsUSA.mapChart(this.areaMapUSA.nativeElement, {
            chart: {
              type: "map",
              height: 370,
              width: 370,
              backgroundColor: "lightgray",
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/usaflag.png'   height='19px' width='32px' />  USA",
              verticalAlign: "bottom",
              style: {
                fontFamily: this.fontFamilyConstant,
                fontWeight: "bold",
                marginLeft: "8px",
                color: "black",
              },
            },
             tooltip: {
              formatter: function () {
                return (
                  `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`
                );
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: [
              {
                name: "Basemap",
                mapData: USAmap,
                borderColor: "#f1a691 ",
                nullColor: "white",
                showInLegend: false,
              },
              {
                type: "mapbubble",

                data: mapArrayUSA,
                maxSize: "5%",
                color: "#b62027 ",
              },
            ],
          });
        }
        //fetch Canada sites
        {
          const HighchartsCanada = require("highcharts/highmaps.js"),
            Canadamap = require("@highcharts/map-collection/countries/ca/ca-all.geo.json");

          HighchartsCanada.mapChart(this.areaMapCanada.nativeElement, {
            chart: {
              type: "map",
              height: 370,
              width: 370,
              backgroundColor: "lightgray",
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/canadaflag.png'   height='19px' width='32px' />  CANADA",
              verticalAlign: "bottom",
              style: {
                fontFamily: this.fontFamilyConstant,
                fontWeight: "bold",
                marginLeft: "8px",
                color: "black",
              },
            },

            tooltip: {
              formatter: function () {
                return (
                  `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`
                );
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: [
              {
                name: "Basemap",
                mapData: Canadamap,
                borderColor: "#f1a691 ",
                nullColor: "white",
                showInLegend: false,
              },
              {
                type: "mapbubble",

                data: mapArrayCanada,
                maxSize: "5%",
                color: "#b62027 ",
              },
            ],
          });
        }
        //fetch Mexico sites
        {
          const HighchartsMexico = require("highcharts/highmaps.js"),
            Mexicomap = require("@highcharts/map-collection/countries/mx/mx-all.geo.json");

          HighchartsMexico.mapChart(this.areaMapMexico.nativeElement, {
            chart: {
              type: "map",
              height: 370,
              width: 370,
              backgroundColor: "lightgray",
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/mexicoflag.png'    height='19px' width='32px' />  MEXICO",
              verticalAlign: "bottom",
              style: {
                fontFamily: this.fontFamilyConstant,
                fontWeight: "bold",
                marginLeft: "8px",
                color: "black",
              },
            },

            tooltip: {
              formatter: function () {
                return (
                  `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`
                );
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: [
              {
                name: "Basemap",
                mapData: Mexicomap,
                borderColor: "#f1a691 ",
                nullColor: "white",
                showInLegend: false,
              },
              {
                type: "mapbubble",

                data: mapArrayMexico,
                maxSize: "5%",
                color: "#b62027 ",
              },
            ],
          });
        }
      });
    });
  }

  loadMap() {
    const landingData = {
      filter: {
        userId: "0",
        bpgId: "0",
        countryName: "string",
      },
      moduleId: 0,
      page: 0,
      presentRole: "string",
      searchTerm: "string",
      size: 0,
      sortDirection: "ASC",
      sortProperty: "string",
      uid: "string",
    };

    this.userService.getsiteMap(landingData).subscribe((data) => {
      this.allsiteList = data;
      const mapArrayUSA = [];
      const mapArrayCanada = [];
      const mapArrayMexico = [];

      const bpgData = {
        filter: {
          userId: "0",
          bpgId: "0",
        },
        moduleId: 0,
        page: 0,
        presentRole: "string",
        searchTerm: "string",
        size: 0,
        sortDirection: "ASC",
        sortProperty: "string",
        uid: "string",
      };
      this.userService.getEachBpg(bpgData).subscribe((data) => {
        this.ergListDetails = data;
        if (data !== null && data !== undefined) {
          this.totalMembershipCount = this.ergListDetails.totalMembershipCount;
          this.totalSites = this.ergListDetails.totalSites;
          this.totalChapters = this.ergListDetails.totalChapters;

          for (const letAllSite of this.allsiteList) {
            if (letAllSite.countryName === "USA"){
              mapArrayUSA.push({
                z: letAllSite.membershipCount,
                membershipCount: letAllSite.membershipCount,
                parentState: letAllSite.siteName,
                lat: letAllSite.siteLatitude,
                lon: letAllSite.siteLongitude,
              });
            }
            if (letAllSite.countryName === "Canada"){
              mapArrayCanada.push({
                z: letAllSite.membershipCount,
                membershipCount: letAllSite.membershipCount,
                parentState: letAllSite.siteName,
                lat: letAllSite.siteLatitude,
                lon: letAllSite.siteLongitude,
              });
            }
            if (letAllSite.countryName === "Mexico"){
              mapArrayMexico.push({
                z: letAllSite.membershipCount,
                membershipCount: letAllSite.membershipCount,
                parentState: letAllSite.siteName,
                lat: letAllSite.siteLatitude,
                lon: letAllSite.siteLongitude,
              });
            }
          }
        }
        {
          const HighchartsUSA = require("highcharts/highmaps.js"),
            USAmap = require("@highcharts/map-collection/countries/us/custom/us-all-mainland.geo.json");

          HighchartsUSA.mapChart(this.areaMapUSA.nativeElement, {
            chart: {
              type: "map",
              height: 370,
              width: 370,
              backgroundColor: "lightgray",
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/usaflag.png'    height='19px' width='32px'/>  USA",
              verticalAlign: "bottom",
              style: {
                fontFamily: this.fontFamilyConstant,
                fontWeight: "bold",
                marginLeft: "8px",
                color: "black",
              },
            },

            tooltip: {
              formatter: function () {
                return (`<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`
                );
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },

            series: [
              {
                name: "Basemap",
                mapData: USAmap,
                borderColor: "#f1a691 ",
                nullColor: "white",
                showInLegend: false,
              },
              {
                type: "mapbubble",

                data: mapArrayUSA,
                maxSize: "5%",
                color: "#b62027 ",
              },
            ],
          });
        }
        //canada select all
        {
          const HighchartsCanada = require("highcharts/highmaps.js"),
            Canadamap = require("@highcharts/map-collection/countries/ca/ca-all.geo.json");

          HighchartsCanada.mapChart(this.areaMapCanada.nativeElement, {
            chart: {
              type: "map",
              height: 370,
              width: 370,
              backgroundColor: "lightgray",
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/canadaflag.png'    height='19px' width='32px' />  CANADA",
              verticalAlign: "bottom",
              style: {
                fontFamily: this.fontFamilyConstant,
                fontWeight: "bold",
                marginLeft: "8px",
                color: "black",
              },
            },

            tooltip: {
              formatter: function () {
                return (
                  `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`
                );
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: [
              {
                name: "Basemap",
                mapData: Canadamap,
                borderColor: "#f1a691 ",
                nullColor: "white",
                showInLegend: false,
              },
              {
                type: "mapbubble",

                data: mapArrayCanada,
                maxSize: "5%",
                color: "#b62027 ",
              },
            ],
          });
        }

        {
          const HighchartsMexico = require("highcharts/highmaps.js"),
            Mexicomap = require("@highcharts/map-collection/countries/mx/mx-all.geo.json");

          HighchartsMexico.mapChart(this.areaMapMexico.nativeElement, {
            chart: {
              type: "map",
              height: 370,
              width: 370,
              backgroundColor: "lightgray",
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/mexicoflag.png'   height='19px' width='32px' />  MEXICO",
              verticalAlign: "bottom",
              style: {
                fontFamily: this.fontFamilyConstant,
                fontWeight: "bold",
                marginLeft: "8px",
                color: "black",
              },
            },

            tooltip: {
              formatter: function () {
                return (
                  `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`
                );
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },

            series: [
              {
                name: "Basemap",
                mapData: Mexicomap,
                borderColor: "#f1a691 ",
                nullColor: "white",
                showInLegend: false,
              },
              {
                type: "mapbubble",

                data: mapArrayMexico,
                maxSize: "5%",
                color: "#b62027 ",
              },
            ],
          });
        }
      });
    });
  }

  /** get list of di resource
   * @class DIComponent
   * @method getDiResouceList
   */
  getDiResouceList() {
    this.LandingPaginationDTO.size = this.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
    this.LandingPaginationDTO.sortProperty = "resourceOrder";
    this.LandingPaginationDTO.filter = { diFlag: "diHomePage" };

    this.diHomeService
      .getDiResouceList(this.LandingPaginationDTO)
      .subscribe((data) => {
        if(data!=null && data!=undefined){
          this.diResouceList = data.content;
          this.refreshSelectedFolderUrls();
        }
      });
  }

  /** get list of di Folders
   * @class DIComponent
   * @method getDiFolderList
   */
  getDiFolderList() {
    this.landingData = {
      filter: {},
      moduleId: 0,
      size: 50,
      presentRole: "",
      searchTerm: "",
      sortDirection: "ASC",
      sortProperty: "folder_order",
      uid: "",
    };

    this.userService
      .getDiDocumentsFolder(this.landingData)
      .subscribe((data) => {
        this.folderNameList = data.content;
        for (const folder of this.folderNameList) {
          folder.Maxmin = "+";
        }
      });
  }

  /** For download files of the events
   * @class EventViewDetailsComponent
   * @method downloadAttachments
   */
  downloadAttachments(urls, i,folderName,fileName) {
    const extension = urls.substring(urls.lastIndexOf(".") + 1);
    const link = document.getElementById("downloadFiles" + i);
    link.setAttribute("href", urls);
    link.setAttribute("download", urls);
    if (extension.includes("mp4")) {
      link.setAttribute("target", "_blank");
    }
    if (extension === "pdf" || "csv") {
      link.setAttribute("target", "_blank");
    }
    this.logUserAction(folderName,fileName);
  }

  /** For displaying full description
   * @class showFullDescComponent
   * @method showFullDesc
   */
  showFullDesc(newsid) {
    for (const news of this.diErgNewsList) {
      if (news.diNewsId === newsid) {
        news.showFullWord = true;
      }
    }
  }

  /** For displaying files based on folder selection
   * @class EventViewDetailsComponent
   * @method selectdiFolder
   */
  selectdiFolder(folderid) {
    this.fileList = [];

    for (const resource of this.diResouceList) {
      if (resource.folderId === folderid) {
        this.fileList.push(resource);
      }
    }
    for (const folderName of this.folderNameList) {
      if (folderName.folderId === folderid) {
        if (
          folderName.showFolder === false ||
          folderName.showFolder === undefined ||
          folderName.showFolder === null
        ) {
          folderName.Maxmin = "-";
          folderName.showFolder = true;
        } else {
          folderName.Maxmin = "+";
          folderName.showFolder = false;
        }
      } else {
        folderName.Maxmin = "+";
        folderName.showFolder = false;
      }
    }
  }

  clickMore(type) {
    switch (type) {
      case "Description":
        this.flag1 = true;
        break;

      case "News":
        this.flag2 = true;
        break;

      case "Resource":
        this.flag3 = true;
        break;

      case "Naac":
        this.flag4 = true;
        break;
    }
  }

  logUserAction(folderName,fileName) {
    const data = {
      userId : this.loginUserId,
      categoryDescription : folderName,
      subcategoryDescription : fileName
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

  refreshSelectedFolderUrls(){
    if(this.fileList.length>0){
      const folderId = this.fileList[0].folderId;
      this.fileList = [];
      for (const resource of this.diResouceList) {
        if (resource.folderId === folderId) {
          this.fileList.push(resource);
        }
      }
    }
  }
}
